/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterX = createReactComponent("circle-letter-x", "IconCircleLetterX", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 8l4 8", key: "svg-1" }],
  ["path", { d: "M10 16l4 -8", key: "svg-2" }]
]);

export { IconCircleLetterX as default };
//# sourceMappingURL=IconCircleLetterX.js.map
